import { getDocumentMeta } from "utils/getDocumentMeta";

export const areFirstAvailableApptsByDefaultEnabled = (): boolean => {
  return getDocumentMeta("enable_first_available_appts_by_default") === "1";
};
